module.exports = __webpack_public_path__ + "static/media/help8.7cbc1844.png";